const selectors = {
  slideruleOpen: 'data-sliderule-open',
  slideruleClose: 'data-sliderule-close',
  sliderulePane: 'data-sliderule-pane',
  slideruleWrappper: '[data-sliderule]',
  focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
  children: `:scope > [data-animates], 
             :scope > * > [data-animates], 
             :scope > * > * >[data-animates],
             :scope > .sliderule-grid  > *`,
};

const classes = {
  isVisible: 'is-visible',
};

let sections = {};

class HeaderMobileSliderule {
  constructor(el) {
    this.sliderule = el;
    this.wrapper = el.closest(selectors.wrapper);
    this.key = this.sliderule.id;
    const btnSelector = `[${selectors.slideruleOpen}='${this.key}']`;
    const exitSelector = `[${selectors.slideruleClose}='${this.key}']`;
    this.trigger = document.querySelector(btnSelector);
    this.exit = document.querySelector(exitSelector);
    this.pane = document.querySelector(`[${selectors.sliderulePane}]`);
    this.children = this.sliderule.querySelectorAll(selectors.children);

    this.trigger.setAttribute('aria-haspopup', true);
    this.trigger.setAttribute('aria-expanded', false);
    this.trigger.setAttribute('aria-controls', this.key);

    this.clickEvents();
    this.staggerChildAnimations();
  }
  clickEvents() {
    this.trigger.addEventListener('click', function() {
      this.showSliderule();
    }.bind(this));
    this.exit.addEventListener('click', function() {
      this.hideSliderule();
    }.bind(this));
  }
  keyboardEvents() {
    this.trigger.addEventListener('keyup', function(evt) {
      if (evt.which !== window.theme.keyboardKeys.SPACE) { return; }
      this.showSliderule();
    }.bind(this));
    this.sliderule.addEventListener('keyup', function(evt) {
      if (evt.which !== window.theme.keyboardKeys.ESCAPE) { return; }
      this.hideSliderule();
      this.buttons[0].focus();
    }.bind(this));
  }
  staggerChildAnimations() {
    this.children.forEach((child, index) => {
      child.style.transitionDelay = `${((index * 50) + 10)}ms`;
    });
  }
  hideSliderule() {
    this.sliderule.classList.remove(classes.isVisible);
    this.children.forEach((el) => { el.classList.remove(classes.isVisible); });
    const newPosition = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
    this.pane.setAttribute(selectors.sliderulePane, newPosition);
  }
  showSliderule() {
    this.sliderule.classList.add(classes.isVisible);
    this.children.forEach((el) => { el.classList.add(classes.isVisible); });
    const newPosition = parseInt(this.pane.dataset.sliderulePane, 10) + 1;
    this.pane.setAttribute(selectors.sliderulePane, newPosition);
  }
}

const headerMobileSliderule = {
  onLoad() {
    sections[this.id] = [];
    const els = this.container.querySelectorAll(selectors.slideruleWrappper);
    els.forEach(el => {
      sections[this.id].push(new HeaderMobileSliderule(el));
    });
  },
  onUnload: function() {
    sections[this.id].forEach(el => {
      if (typeof el.unload === 'function') {
        el.unload();
      }
    });
  },
};

export default headerMobileSliderule;
